"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addonControls = void 0;
const addonControls = () => {
    // const upgrades: HTMLElement = document.querySelector('.product-upgrades');
    // function setLinkedUpgrade(target, upgrade){
    //
    //   if (target.matches('[value="Lockable Cab"]')) {
    //
    //     let standardOption : HTMLInputElement = document.querySelector('.product-upgrades__option input[value="Acrylic Windscreen"]');
    //     let selectedOption : HTMLInputElement = standardOption
    //
    //     if (selectedOption) {
    //
    //       if(upgrade === true) {
    //         selectedOption = document.querySelector('.product-upgrades__option input[value="Glass Windscreen"]');
    //         standardOption.disabled = true;
    //       } else {
    //         standardOption.disabled = false;
    //       }
    //
    //       selectedOption.checked = true;
    //       let addonOption: HTMLOptionElement = document.querySelector('[data-label="' + selectedOption.value + '"]')
    //       let upgradeSelect: HTMLSelectElement = addonOption.closest('select');
    //       let lastOption: HTMLOptionElement = upgradeSelect.querySelector('option:last-child');
    //
    //       upgradeSelect.value = selectedOption.value === 'Glass Windscreen' ? lastOption.value : addonOption.value
    //       upgradeSelect.dispatchEvent(new Event('change', {bubbles: true}));
    //     }
    //
    //   }
    //
    // }
    // if (upgrades) {
    //   upgrades.querySelectorAll('[data-default="true"]').forEach(function (element: HTMLInputElement) {
    //     element.checked = true;
    //     let addonOption: HTMLOptionElement = document.querySelector('[data-label="' + element.value + '"]');
    //     if (addonOption) {
    //       addonOption.closest('select').value = addonOption.value;
    //     }
    //   });
    // }
    document.addEventListener('click', function (e) {
        const target = e.target;
        // if (target.matches('[data-control="upgrade"]')) {
        //   let addonOption: HTMLOptionElement = document.querySelector('[data-label="' + target.value + '"]');
        //   if (addonOption) {
        //     let upgradeSelect: HTMLSelectElement = addonOption.closest('select');
        //     upgradeSelect.value = addonOption.value;
        //     upgradeSelect.dispatchEvent(new Event('change', {bubbles: true}));
        //   }
        // }
        if (target.matches('[data-control="extra"]')) {
            let addonOption = document.querySelector('[data-label="' + target.value + '"]');
            if (addonOption) {
                let extraSelect = addonOption.closest('select');
                if (target.checked) {
                    extraSelect.value = addonOption.value;
                    // setLinkedUpgrade(target, true)
                }
                else {
                    extraSelect.value = '';
                    // setLinkedUpgrade(target, false)
                }
                extraSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });
};
exports.addonControls = addonControls;
